import { parse } from 'papaparse'
import { readCSVFile } from '@/models/readCSVFileUtil'
import { makeTemporaryId } from '@/models/Simulation/SimulationFormDelivery'

export default class BulkAddLocationFormModel {
  constructor({ locationGroupName, geocoder }) {
    this.locationGroupName = locationGroupName
    this.geocoder = geocoder
    this.csv = ''
  }

  get parsedLocations() {
    return parseCSV(this.csv)
  }

  async readCSVFile(file) {
    const text = await readCSVFile(file)
    this.csv = `${this.csv.trim()}\n${text}`.trim()
  }

  async createLocations() {
    const locationOrErrors = await Promise.all(
      this.parsedLocations.map(async ({ name, address }, i) => {
        const [latLng, error] = await this.geocoder(address)
        if (error) {
          error.location = { name, address }
          error.locationGroupName = this.locationGroupName
          return error
        }
        const { lat, lng } = latLng
        const location = {
          id: makeTemporaryId(i),
          name,
          shapeType: 'point',
          shape: {
            coordinates: [lng, lat],
            type: 'Point',
          },
          added: true,
          status: 'active',
        }
        return location
      }),
    )

    const errors = locationOrErrors.filter(obj => obj instanceof Error)
    const locations = locationOrErrors.filter(obj => !(obj instanceof Error))

    if (errors.length > 0) {
      const error = new Error(
        `一部登録できなかった地点があります。\n入力欄をご確認ください。`,
      )
      error.errors = errors
      throw error
    }
    return locations
  }
}

/**
 * csvから地点名と住所を取り出す
 * @param {string} csv
 * @return {{ name: string, address: string }[]}
 */
const parseCSV = csv => {
  const result = parse(csv)
  return result.data.map(([name, address]) => ({
    name,
    address,
  }))
}
